import React, { Component } from "react";
import { connect } from "react-redux";

import { storeItem } from "utils/tokenStore";
import { setProfile } from "actions/profile";
import Axios from "axios";
import getDomainURL from "utils/api";
import Cookies from "universal-cookie";
import { COOKIES_LOGGED_IN } from "constants/Constants";
//import { sendOTP, verifyOTP } from "utils/otpService";

const HOC = (WrappedComponent) => {
	class WithHOC extends Component {
		state = {
			loading: false,
			showPassword: false,
			showErrorMessage: false,
			// OTP related
			showOTPModal: false,
			otpError: "",
			tempUserData: null, // Store user data temporarily until OTP is verified
			tempEmail: "", // Store email for OTP verification
		};

		cookies = new Cookies();

		onChangeHOC = (val, context) => this.setState({ [context]: val });

		onClickLogin = ({ email, password }) => {
			this.setState({ loading: true, showErrorMessage: false });

			Axios.post(`${getDomainURL()}/auth-user?platform=jobmacha`, {
				email,
				password,
				encode_type: "JWT",
			})
				.then((response) => {
					// Store user data temporarily (kept, so we don't change overall flow too much)
					this.setState(
						{
							tempUserData: response.data,
							tempEmail: email,
						},
						() => {
							// OTP (disabled): comment out OTP sending + modal open, and proceed to login
							// return sendOTP(email);
							// this.setState({
							// 	loading: false,
							// 	showOTPModal: true,
							// 	otpError: "",
							// });

							this.completeLogin();
						}
					);
				})
				.catch((error) => {
					console.error("Login or OTP send error:", error);
					this.setState({
						showErrorMessage: true,
						loading: false,
						tempUserData: null,
						tempEmail: "",
					});
				});
		};

		onVerifyOTP = (otpCode) => {
			this.setState({ loading: true, otpError: "" });

			// OTP (disabled)
			// verifyOTP(this.state.tempEmail, otpCode)
			// 	.then((response) => {
			// 		// Check if OTP verification was successful
			// 		if (response.data.success) {
			// 			// Complete login process
			// 			this.completeLogin();
			// 		} else {
			// 			throw new Error("Invalid OTP");
			// 		}
			// 	})
			// 	.catch((error) => {
			// 		const errorMessage = error.response?.data?.error || "Invalid OTP. Please try again.";
			// 		this.setState({
			// 			loading: false,
			// 			otpError: errorMessage,
			// 		});
			// 	});

			this.setState({
				loading: false,
				otpError: "OTP is currently disabled.",
			});
		};

		onResendOTP = () => {
			this.setState({ loading: true, otpError: "" });

			// OTP (disabled)
			// sendOTP(this.state.tempEmail)
			// 	.then(() => {
			// 		this.setState({
			// 			loading: false,
			// 			otpError: "", // Clear any previous errors
			// 		});
			// 		// Optionally show a success message
			// 	})
			// 	.catch((error) => {
			// 		console.error("Resend OTP error:", error);
			// 		this.setState({
			// 			loading: false,
			// 			otpError: "Failed to resend OTP. Please try again.",
			// 		});
			// 	});

			this.setState({
				loading: false,
				otpError: "OTP is currently disabled.",
			});
		};

		onCloseOTPModal = () => {
			this.setState({
				showOTPModal: false,
				otpError: "",
				tempUserData: null,
				tempEmail: "",
				loading: false,
			});
		};

		completeLogin = () => {
			const { tempUserData } = this.state;

			if (!tempUserData) {
				this.setState({
					showErrorMessage: true,
					showOTPModal: false,
					loading: false,
				});
				return;
			}

			this.cookies.set(COOKIES_LOGGED_IN, JSON.stringify(tempUserData.user), { path: '/' });
			
			this.props.setProfile(tempUserData.user);

			storeItem("CHINA_PRESS_TOKEN", tempUserData.access_token);
			storeItem("SHOW_SIDE_MENU", tempUserData.user.roles.find(role => role.is_read === true) ? true : false);

			this.setState({
				showOTPModal: false,
				loading: false,
			});

			this.props.history.push("/dashboard/post");
		};

		render = () => {
			return (
				<WrappedComponent
					{...this.props}
					showPassword={this.state.showPassword}
					showErrorMessage={this.state.showErrorMessage}
					onLoadLogin={this.state.loading}
					onChangeHOC={this.onChangeHOC}
					onClickLogin={this.onClickLogin}
					// OTP related (OTP APIs disabled in actions)
					showOTPModal={this.state.showOTPModal}
					otpError={this.state.otpError}
					tempEmail={this.state.tempEmail}
					onVerifyOTP={this.onVerifyOTP}
					onResendOTP={this.onResendOTP}
					onCloseOTPModal={this.onCloseOTPModal}
				/>
			);
		};
	}
	const mapStateToProps = (state) => ({ data: state });
	return connect(mapStateToProps, {
		setProfile,
	})(WithHOC);
};
export default HOC;
